import React from 'react';
import {
  AlertCircle,
  Loader2,
} from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../../ui/dialog';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '../../ui/alert-dialog';
import { Button } from '../../ui/button';
import { Input } from '../../ui/input';
import { Label } from '../../ui/label';
import { Textarea } from '../../ui/textarea';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../ui/select';
import { useAdminContext } from '../../../contexts/AdminContext';

const ConfirmationModals = () => {
  const {
    deleteLoading,
    handleDeleteAllData,
    handleDeleteFeedback,
    handleSeedDatabase,
    seedLoading,
    setShowDeleteConfirm,
    setShowDeleteFeedbackConfirm,
    setShowSeedConfirm,
    showDeleteConfirm,
    showDeleteFeedbackConfirm,
    showSeedConfirm,
  } = useAdminContext();

  return (
    <>
    <AlertDialog open={showSeedConfirm} onOpenChange={setShowSeedConfirm}>
      <AlertDialogContent className="bg-white dark:bg-slate-800 border-slate-200 dark:border-slate-700">
        <AlertDialogHeader>
          <AlertDialogTitle className="text-slate-900 dark:text-white">Database Vullen met Demo Data</AlertDialogTitle>
          <AlertDialogDescription className="text-slate-500 dark:text-slate-500 dark:text-slate-400">
            Dit zal bestaande use cases en workshop bookings overschrijven met verse demo-data. 
            Bestaande quickscans met unieke emails worden behouden.
            <br /><br />
            Weet je zeker dat je door wilt gaan?
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel className="bg-slate-100 dark:bg-slate-700 text-slate-900 dark:text-white border-slate-300 dark:border-slate-600 hover:bg-slate-600">
            Annuleren
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={handleSeedDatabase}
            className="bg-blue-500 hover:bg-blue-600 text-slate-900 dark:text-white"
          >
            {seedLoading ? (
              <>
                <Loader2 className="h-4 w-4 mr-2 animate-spin" />
                Bezig...
              </>
            ) : (
              'Ja, vul database'
            )}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>

    {/* Delete All Data Confirmation Dialog */}
    <AlertDialog open={showDeleteConfirm} onOpenChange={setShowDeleteConfirm}>
      <AlertDialogContent className="bg-white dark:bg-slate-800 border-slate-200 dark:border-slate-700">
        <AlertDialogHeader>
          <AlertDialogTitle className="text-slate-900 dark:text-white flex items-center gap-2">
            <AlertCircle className="h-5 w-5 text-red-500" />
            Alle Data Verwijderen
          </AlertDialogTitle>
          <AlertDialogDescription className="text-slate-500 dark:text-slate-500 dark:text-slate-400">
            <span className="text-red-400 font-medium">Waarschuwing:</span> Dit zal ALLE gegevens permanent verwijderen:
            <ul className="list-disc list-inside mt-2 space-y-1">
              <li>Alle quickscans</li>
              <li>Alle use cases</li>
              <li>Alle workshop bookings</li>
              <li>Alle use case submissions</li>
            </ul>
            <br />
            <span className="text-red-400 font-medium">Deze actie kan niet ongedaan worden gemaakt!</span>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel className="bg-slate-100 dark:bg-slate-700 text-slate-900 dark:text-white border-slate-300 dark:border-slate-600 hover:bg-slate-600">
            Annuleren
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={handleDeleteAllData}
            className="bg-red-500 hover:bg-red-600 text-slate-900 dark:text-white"
          >
            {deleteLoading ? (
              <>
                <Loader2 className="h-4 w-4 mr-2 animate-spin" />
                Bezig...
              </>
            ) : (
              'Ja, verwijder alles'
            )}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>

    {/* Delete Feedback Confirmation */}
    <AlertDialog open={showDeleteFeedbackConfirm} onOpenChange={setShowDeleteFeedbackConfirm}>
      <AlertDialogContent className="bg-white dark:bg-slate-800 border-slate-200 dark:border-slate-700">
        <AlertDialogHeader>
          <AlertDialogTitle className="text-slate-900 dark:text-white">Feedback Verwijderen</AlertDialogTitle>
          <AlertDialogDescription className="text-slate-500 dark:text-slate-500 dark:text-slate-400">
            Weet u zeker dat u deze feedback wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel className="bg-slate-100 dark:bg-slate-700 text-slate-900 dark:text-white border-slate-300 dark:border-slate-600 hover:bg-slate-600">
            Annuleren
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={handleDeleteFeedback}
            className="bg-red-500 hover:bg-red-600 text-slate-900 dark:text-white"
          >
            Verwijderen
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
    </>
  );
};

export default ConfirmationModals;
